import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
// import { boolean } from 'yup';
import { extensionTypeList, getOBLForInvoiceRequest/*, populateExtensionRequest, getExtensionRequest */ } from '../dashboard/actions/instruction';
import { getInvoiceRequestDetails } from './InvoiceRequestActions';
// import { deleveryLocTypeList, getOBLDetails, returnLocTypeList } from '../dashboard/actions/instruction';

// import { Item } from 'react-bootstrap/lib/Breadcrumb';

export interface invoiceRequestContainerDetails {
  needExtensionFor: string;
  plannedPickupDate?: Date | null;
  // containerReturnDate?: Date | null;
  // Not used by Invoice Request today — kept for future edit/view saved request flow
  // userRemark?: string;
  // status: string;
  // rejectRemarks: string;
  extensionRequestId: number | null;
  // customerCode?: string | null;
  customerEmailId?: string | null;

}

export interface invoiceRequestContainerTable {
  // id: number | null;
  invoiceRequestContainerId: number | null;
  invoiceRequestInstructionId: number | null;
  needExtensionFor: string;
  plannedPickupDate?: Date | null;
  // containerReturnDate?: Date | null;
  containerNo: string;
  deliveryZone: string;
  deliveryZoneName: string;
  subLocation: string;
  subLocationName: string;
  modeOfTransport: string;
  typeOfTrailer: string;
  isHazardous: boolean;
  // deliveryLocationType: string;
  // returnLocation: string;
  currency: string;


}

export interface IInvoiceRequestContainer {
  data: Array<invoiceRequestContainerTable>;
  invoiceRequestContainerDetails: invoiceRequestContainerDetails;
  extensionTypeOptions: any[];
  // Not used by Invoice Request today — kept for future delivery/return location columns
  // deleveryTypeLocation: any[];
  // returnTypeLocation: any[],

  localstorage: boolean;
  //containerList:any[]
  // dataLoading: boolean;

}


const initialState: IInvoiceRequestContainer = {
  data: [],
  localstorage: false,
  //  dataLoading: true,
  invoiceRequestContainerDetails: {
    needExtensionFor: "0",
    plannedPickupDate: null,
    // containerReturnDate: null,
    // userRemark: '',
    // status: '',
    // rejectRemarks: '',
    extensionRequestId: null,
    // customerCode: ''

  },
  extensionTypeOptions: [],
  // deleveryTypeLocation: [],
  // returnTypeLocation: [],

  //containerList:[]



};

const safeDate = (value: any): Date | null => {
  if (!value) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const invoiceRequestContainerSlice = createSlice({
  name: 'invoiceRequestContainer',
  initialState,
  reducers: {
    clearData: (state) => {
      state.data = []

    },
    updateSelectedneedExtensionFor: (state, action: PayloadAction<any>) => {
      state.data.forEach((Item) => { Item.needExtensionFor = action.payload ?? '0' })

    },
    updateSelectedDeliveryZone: (state, action: PayloadAction<any>) => {
      state.data.forEach((item) => {
        item.deliveryZone = action.payload.value ?? '';
        item.deliveryZoneName = action.payload.label ?? '';
        item.subLocation = '';
        item.subLocationName = '';
        item.modeOfTransport = '';
        item.typeOfTrailer = '';
      });
    },
    updateSelectedSubLocation: (state, action: PayloadAction<any>) => {
      state.data.forEach((item) => {
        item.subLocation = action.payload.value ?? '';
        item.subLocationName = action.payload.label ?? '';
      });
    },
    updateSelectedModeOfTransport: (state, action: PayloadAction<any>) => {
      state.data.forEach((item) => {
        item.modeOfTransport = action.payload ?? '';
        if (String(action.payload) === '1') item.typeOfTrailer = '';
      });
    },
    updateSelectedTypeOfTrailer: (state, action: PayloadAction<any>) => {
      state.data.forEach((item) => { item.typeOfTrailer = action.payload ?? ''; });
    },
    updateContainerTransportField: (state, action: PayloadAction<any>) => {
      const row = state.data.find((item) => item.containerNo === action.payload.containerNo);
      if (!row) return;

      const { field, value, label } = action.payload;
      if (field === 'deliveryZone') {
        row.deliveryZone = value ?? '';
        row.deliveryZoneName = label ?? '';
        row.subLocation = '';
        row.subLocationName = '';
        row.modeOfTransport = '';
        row.typeOfTrailer = '';
      } else if (field === 'subLocation') {
        row.subLocation = value ?? '';
        row.subLocationName = label ?? '';
      } else if (field === 'modeOfTransport') {
        row.modeOfTransport = value ?? '';
        if (String(value) === '1') row.typeOfTrailer = '';
      } else if (field === 'typeOfTrailer') {
        row.typeOfTrailer = value ?? '';
      } else if (field === 'isHazardous') {
        row.isHazardous = !!value;
      }
    },
    // updateSelectedDeleveryLocType: (state, action: PayloadAction<any>) => {
    //   state.data.forEach((Item) => {
    //     Item.deliveryLocationType = action.payload
    //   })
    // },
    // updateSelectedReturnLocType: (state, action: PayloadAction<any>) => {
    //   state.data.forEach((Item) => {
    //     Item.returnLocation = action.payload
    //   })
    // },
    updateSelectedCcy: (state, action: PayloadAction<any>) => {
      state.data.forEach((Item) => { Item.currency = action.payload })
    },
    updateSelectedPlannedPickupDate: (state, action: PayloadAction<any>) => {
      state.data.forEach((Item) => { Item.plannedPickupDate = action.payload })
    },
    // updateSelectedContainerReturnDate: (state, action: PayloadAction<any>) => {
    //   state.data.forEach((Item) => { Item.containerReturnDate = action.payload })
    // },
    // updateNavigateFlag: (state, action: PayloadAction<any>) => {
    //   state.localstorage = action.payload
    // },
    updateSelectedContainerNo: (state, action: PayloadAction<any>) => {
      const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
  
      if (!row) return
      row.needExtensionFor = action.payload.needExtensionFor ?? '0'
      // if (action.payload.needExtensionFor != '1004') row.deliveryLocationType = '0'

    },
    // updateSelectedDeleveryLocTypeOnContainer: (state, action: PayloadAction<any>) => {
    //   const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
    //   if (!row) return
    //   row.deliveryLocationType = action.payload.deliveryLocationType

    // },
    // updateSelectedReturnLocTypeOnContainer: (state, action: PayloadAction<any>) => {
    //   const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
    //   if (!row) return
    //   row.returnLocation = action.payload.returnLocation

    // },
    updateSelectedCCyOnContainer: (state, action: PayloadAction<any>) => {
      const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
      if (!row) return
      row.currency = action.payload.currency
    },
    updateSelectedPickupDate: (state, action: PayloadAction<any>) => {
      const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
      if (!row) return
      row.plannedPickupDate = action.payload.plannedPickupDate
    },

    // updateSelectedReturnDate: (state, action: PayloadAction<any>) => {
    //   const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
    //   if (!row) return
    //   row.containerReturnDate = action.payload.containerReturnDate
    // },

    clearTableInputValues: (state) => {
      state.data.forEach((item) => {
        item.needExtensionFor = '0'
        item.plannedPickupDate = null
        // item.containerReturnDate = null

        item.currency = ''
        // item.deliveryLocationType = '0'
        // item.returnLocation = '0'

      })
    },
    // setContainerData: (state, action: PayloadAction<invoiceRequestContainerTable[]>) => {
    //   state.data = action.payload;
    //   console.log("dffdd", state.data)
    // }
  },
  extraReducers: (builder) => {
    // builder.addCase(getExtensionRequest.pending, (state, action) => {
    //   // state.dataLoading = true;
    //   state.invoiceRequestContainerDetails = {
    //     needExtensionFor: '0',
    //     plannedPickupDate: null,
    //     // containerReturnDate: null,
    //     // userRemark: '',
    //     // status: '',
    //     // rejectRemarks: '',
    //     extensionRequestId: null,
    //     // customerCode: ''
    //   }
    //   state.data = []

    // });

    // builder.addCase(getExtensionRequest.fulfilled, (state, action) => {
    //   // state.invoiceRequestContainerDetails.status = action?.payload?.data?.status
    //   // state.invoiceRequestContainerDetails.rejectRemarks = action?.payload?.data?.remarks
    //   // state.invoiceRequestContainerDetails.userRemark = action?.payload?.data?.userRemarks
    //   state.invoiceRequestContainerDetails.extensionRequestId = action?.payload?.data?.extensionRequestId
    //   // state.invoiceRequestContainerDetails.customerCode = action?.payload?.data?.customerCode
    //   state.invoiceRequestContainerDetails.customerEmailId = action?.payload?.data?.customerEmailId
    //   state.data = []

    //   action.payload.data?.containerDetails?.forEach?.((item: any) => {
    //     console.log(item.pickupLocation,'<<deliveryLocationType')
    //     state.data.push({
    //       // id: item.containerPickupId,
    //       invoiceRequestContainerId: null,
    //       invoiceRequestInstructionId: null,
    //       needExtensionFor: item.pickupLocation ?? 0,
    //       plannedPickupDate: safeDate(item.pickupDate),
    //       // containerReturnDate: safeDate(item.containerReturnDate),
    //       // deliveryLocationType: item.deliveryLocationType ?? 0,
    //       // returnLocation: item.returnLocation ?? 0,
    //       containerNo: item.cntNo,
    //       currency: item.currency ?? ''
    //     })
    //   })

    // });

    builder.addCase(getInvoiceRequestDetails.pending, (state) => {
      state.data = [];
    });

    builder.addCase(getInvoiceRequestDetails.fulfilled, (state, action) => {
      state.data = action.payload.data?.containerTableData ?? [];
    });

    // builder.addCase(populateExtensionRequest.fulfilled, (state, action) => {
    //   // state.invoiceRequestContainerDetails.status = action?.payload?.data?.status
    //   // state.invoiceRequestContainerDetails.rejectRemarks = action?.payload?.data?.remarks
    //   // state.invoiceRequestContainerDetails.userRemark = action?.payload?.data?.userRemarks
    //   state.invoiceRequestContainerDetails.extensionRequestId = action?.payload?.data?.extensionRequestId
    //   // state.invoiceRequestContainerDetails.customerCode = action?.payload?.data?.customerCode
    //   state.invoiceRequestContainerDetails.customerEmailId = action?.payload?.data?.customerEmailId

    //   action.payload.data?.containerDetails?.forEach?.((item: any) => {
    //     const row = state.data.find((i) => item.cntNo == i.containerNo)
    //     if (!row) { return }

    //     row.needExtensionFor = item.pickupLocation ?? 0
    //     row.plannedPickupDate = safeDate(item.pickupDate)
    //     // row.containerReturnDate = safeDate(item.containerReturnDate)

    //     // row.deliveryLocationType = item.deliveryLocationType ?? 0
    //     // row.returnLocation = item.returnLocation ?? 0
    //     row.currency = item.currency ?? ''
    //   })

    // });

    builder.addCase(extensionTypeList.fulfilled, (state, action) => {
      state.extensionTypeOptions = action.payload;

    })
    // builder.addCase(deleveryLocTypeList.fulfilled, (state, action) => {
    //   state.data.forEach((Item) => {
    //     if (!Item.deliveryLocationType || Item.deliveryLocationType === '0') {
    //     Item.deliveryLocationType = action.payload?.[0]?.value ?? ""
    //     }
    //   })
    //   state.deleveryTypeLocation = action.payload
    // })

    // builder.addCase(returnLocTypeList.fulfilled, (state, action) => {
    //   state.data.forEach((Item) => {
    //      if (!Item.returnLocation || Item.returnLocation === '0') {
    //     Item.returnLocation = action.payload?.[0]?.value ?? ""
    //      }
    //   })
    //   state.returnTypeLocation = action.payload
    // })

    builder.addCase(getOBLForInvoiceRequest.fulfilled, (state, action) => {
      state.data = (action.payload?.containerList ?? []).map((i: any) => ({
        containerNo: i.containerNo,
        invoiceRequestContainerId: null,
        invoiceRequestInstructionId: null,
        needExtensionFor: '0',
        plannedPickupDate: null,
        deliveryZone: '',
        deliveryZoneName: '',
        subLocation: '',
        subLocationName: '',
        modeOfTransport: '',
        typeOfTrailer: '',
        isHazardous: !!(i.isHazardous ?? action.payload?.hazardousCargo),
        currency: 'XOF',
      }));
    })
  }
});


export const {
  clearData,
  updateSelectedneedExtensionFor,
  updateSelectedDeliveryZone,
  updateSelectedSubLocation,
  updateSelectedModeOfTransport,
  updateSelectedTypeOfTrailer,
  updateContainerTransportField,
  updateSelectedContainerNo,
  updateSelectedPickupDate,
  updateSelectedPlannedPickupDate,
  updateSelectedCCyOnContainer,
  updateSelectedCcy,
  clearTableInputValues,
  // updateNavigateFlag,
  // updateSelectedReturnDate,
  // updateSelectedContainerReturnDate,
  // updateSelectedDeleveryLocTypeOnContainer,
  // updateSelectedDeleveryLocType,
  // updateSelectedReturnLocType,
  // updateSelectedReturnLocTypeOnContainer,
  // setContainerData,
} = invoiceRequestContainerSlice.actions;
export default invoiceRequestContainerSlice.reducer;
